import React, {useEffect, useState} from 'react';
import {FazendaObject} from "../../../models/Fazenda";
import {post} from "../../../utils/frRequest";
import {debug} from "../../../config";
import {
  IonButton,
  IonIcon,
  IonList,
  IonSpinner
} from "@ionic/react";
import {checkmark, chevronBack} from "ionicons/icons";
import AplicacaoMes from "./AplicacaoMes";
import {useAppDispatch} from "../../../lib/hooks";
import {actions} from "../../../lib/app";


interface AplicacoesProps {
  setSecaoAtiva: (secao: string) => void;
  fazenda: FazendaObject;
  calendario: any[];
  rebanho: any[];
  produtos: any[];
  setCalendario: (calendario: any[]) => void;
}

const Aplicacoes: React.FC<AplicacoesProps> = (props) => {
  const [calendario, setCalendario] = useState<any[]>(props.calendario);
  const [calendarioLoaded, setCalendarioLoaded] = useState(props.calendario.length > 0);
  const [calendarioLoading, setCalendarioLoading] = useState(false);
  const dispatch = useAppDispatch();

  // load Calendario padrao
  useEffect(() => {
    if (!calendarioLoaded && !calendarioLoading) {
      setCalendarioLoading(true);

      debug('Calendario.Aplicacoes', 'Loading calendario...');
      post('/veApi/vet_experts/load_calendario_padrao',
        {rebanho: props.rebanho})
        .then(({success, data, error}) => {
          if (!success) {
            dispatch(actions.notifyError('Erro ao carregar calendário padrão de aplicações.'));
            console.error(`Erro inesperado em load_calendario_padrao: ${error}`);
            return;
          }

          setCalendario(data);
          setCalendarioLoaded(true);
          setCalendarioLoading(false);
          debug('calendario_padrao', data);
        });
    }
  }, [props.rebanho, calendarioLoaded, calendarioLoading, dispatch]);

  const setCalendarioOk = (): void => {
    props.setCalendario(calendario);
    props.setSecaoAtiva('home');
  }

  const setMes = (mesId:number, mes:any) => {
    setCalendario(pcal => {
      const ncal: any[] = [];
      for (const i of pcal) {
        if (i.id === mesId)
          ncal.push(mes);
        else
          ncal.push(i);
      }
      return ncal;
    });
  }

  return (
    <>
      <div className="flex items-center">
        <div>
          <IonButton
            onClick={() => props.setSecaoAtiva('home')}
            fill={'clear'}
            style={{
              '--padding-start': '4px',
            }}
          >
            <IonIcon
              slot="icon-only"
              icon={chevronBack}
            />
          </IonButton>
        </div>
        <div className="font-bold text-right text-xl">
          Calendário
        </div>
      </div>

      <div className="flex justify-center mt-4">
        <IonButton
          onClick={setCalendarioOk}
          disabled={!calendarioLoaded}
        >
          <IonIcon icon={checkmark} slot="start"/>
          Confirmar calendário
        </IonButton>
      </div>

      <IonList>
        {
          !calendarioLoaded &&
          <div className="p-8 flex justify-center">
            <IonSpinner/>
          </div>
        }
        {
          calendario.map((mes: any) => (
            <AplicacaoMes
              key={mes.id}
              mes={mes}
              produtos={props.produtos}
              setMes={novoMes => setMes(mes.id, novoMes)}
              rebanho={props.rebanho}
            />
          ))
        }

      </IonList>
    </>
  );
}

export default Aplicacoes;
